import { UPLOAD_CSV_CLIENTS } from '../types/uploadCsvClientsTypes';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  uploadCsvClients,
  uploadCsvClientsPending,
  uploadCsvClientsFulfilled,
  uploadCsvClientsRejected,
} = createAsyncActions(UPLOAD_CSV_CLIENTS, 'uploadCsvClients');


// WEBPACK FOOTER //
// ./src/features/score-card/actions/uploadCsvClientsActions.js